import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

export const useNotifications = () => {
  const { t } = useTranslation(['notifications', 'validation', 'errors']);

  const showNotification = (type, key, options = {}) => {
    const message = t(key, options);
    
    toast[type](message, {
      description: options.description ? t(options.description, options) : undefined,
      duration: options.duration || (type === 'error' ? 5000 : 3000),
    });
  };

  const showSuccess = (key, options = {}) => {
    showNotification('success', key, options);
  };

  const showError = (key, options = {}) => {
    showNotification('error', key, options);
  };

  const showWarning = (key, options = {}) => {
    showNotification('warning', key, options);
  };

  const showInfo = (key, options = {}) => {
    showNotification('info', key, options);
  };

  // Специальные методы для часто используемых уведомлений
  const showSaveSuccess = (entity) => {
    showSuccess(`${entity}_saved`);
  };

  const showSaveError = (entity) => {
    showError(`${entity}_save_failed`);
  };

  const showValidationError = (field, errorKey) => {
    showError(`validation.${field}.${errorKey}`);
  };

  const showNetworkError = () => {
    showError('errors.network.connection_failed');
  };

  const showServerError = () => {
    showError('errors.system.internal_error');
  };

  return {
    showNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showSaveSuccess,
    showSaveError,
    showValidationError,
    showNetworkError,
    showServerError,
  };
};
